import { axiosPrivate } from "./axios";

export interface Feature {
	id: number;
	key: string;
	name: string;
	description: string;
	category: string;
	created_at: string;
}

export interface SubscriptionFeature {
	id: number;
	subscription_id: number;
	feature_key: string;
	created_by_nb_user_id: number | null;
	is_deleted: number;
	created_at: string;
	updated_at: string;
	name: string;
	description: string;
	category: string;
}

// Get all available features
export const getAllFeatures = async (signal?: AbortSignal) => {
	return await axiosPrivate.get<{ message: string; data: Feature[] }>(
		"/auth/features",
		{
			headers: { "Content-Type": "application/json" },
			withCredentials: true,
			signal,
		},
	);
};

// Get features enabled for a subscription
export const getSubscriptionFeatures = async (
	subscriptionId: number,
	signal?: AbortSignal,
) => {
	return await axiosPrivate.get<{
		message: string;
		data: SubscriptionFeature[];
	}>(`/auth/features/subscription/${subscriptionId}`, {
		headers: { "Content-Type": "application/json" },
		withCredentials: true,
		signal,
	});
};

// Enable a feature for a subscription
export const enableSubscriptionFeature = async (
	subscriptionId: number,
	featureKey: string,
	signal?: AbortSignal,
) => {
	return await axiosPrivate.post(
		`/auth/features/subscription/${subscriptionId}`,
		{ feature_key: featureKey },
		{
			headers: { "Content-Type": "application/json" },
			withCredentials: true,
			signal,
		},
	);
};

// Disable a feature for a subscription
export const disableSubscriptionFeature = async (
	subscriptionId: number,
	featureKey: string,
	signal?: AbortSignal,
) => {
	return await axiosPrivate.delete(
		`/auth/features/subscription/${subscriptionId}/${featureKey}`,
		{
			headers: { "Content-Type": "application/json" },
			withCredentials: true,
			signal,
		},
	);
};

// Create a new feature definition (admin only)
export const createFeature = async (
	feature: { key: string; name: string; description?: string; category?: string },
	signal?: AbortSignal,
) => {
	return await axiosPrivate.post("/auth/features", feature, {
		headers: { "Content-Type": "application/json" },
		withCredentials: true,
		signal,
	});
};

// Delete a feature definition (admin only)
export const deleteFeatureDefinition = async (
	featureId: number,
	signal?: AbortSignal,
) => {
	return await axiosPrivate.delete(`/auth/features/${featureId}`, {
		headers: { "Content-Type": "application/json" },
		withCredentials: true,
		signal,
	});
};
